import type { IFormxRepository } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createDeleteFormxFormUseCase({ formxRepository }: Deps) {
  return async function deleteFormxForm(id: string): Promise<void> {
    return formxRepository.deleteForm(id);
  };
}
